import React from 'react';

import HelpPageFooterNotice from '../components/helpPageFooterNotice';

const FlightHelp: React.FC = () => {
  return (
    <>
      <h1>Flight Search</h1>
      <p>
        The Flight Search tool allows you to look up and view the flight status
        of any flight in Cirium's system based on your search criteria. Here's
        how you can use it:
      </p>
      <h2>Filters</h2>
      <p>
        To search for a single flight, enter the airline and flight number of
        the individual flight.
      </p>
      <p>
        To display multiple flights, you can use specific filters such as
        airline, date, route, or flight status type.
      </p>
      <h2>Load Flight View</h2>
      <p>To view the details of a flight, follow these steps:</p>
      <p>
        1. After performing a search, you'll see a list of flights in the
        display.
      </p>
      <p>
        2. Click on the link in the "Flight" column corresponding to the flight
        you want to view.
      </p>

      <h1>Flight View</h1>
      <p>
        The Flight View page provides the current status of a flight within
        Cirium's system. You can access it in two ways:
      </p>
      <p>
        1. While in the Trip View in Trip Center, click on the link associated
        with a specific flight.
      </p>
      <p>2. Click on the link in the "Flight Search" results page.</p>

      <h2>Flight Details</h2>
      <p>
        The Flight Details portion of the Flight View page provides essential
        information about the flight. Here are the details you can expect to
        find:
      </p>
      <ul>
        <li>Departure and arrival times</li>
        <li>Gate and terminal assignments</li>
        <li>Aircraft type</li>
        <li>Flight duration</li>
        <li>Operating and marketing airlines</li>
      </ul>
      <h2>Event Timeline</h2>
      <p>
        The Event Timeline section on the Flight View page includes specific
        updates received regarding the status of the flight. You can track any
        changes or important events related to the flight through this timeline.
      </p>
      <p>
        By utilizing the Flight Search tool and exploring the Flight View page,
        you can stay informed about the status and details of any flight in
        Cirium's system.
      </p>
      <HelpPageFooterNotice />
    </>
  );
};
export default FlightHelp;
